// extracted by mini-css-extract-plugin
module.exports = {"nameWrapper":"styles_nameWrapper__2S99V","name":"styles_name__1zyvo","subname":"styles_subname__15ge3"};